import type { Components, Theme } from '@mui/material';

export const cssBaselineCustomizations: Components<Theme> = {
  MuiCssBaseline: {
    styleOverrides: `
      #nprogress .bar {
        z-index: 1000;
        background: 'secondary.main';
      }
    `,
  },
};
